import React from "react";
import AboutSection from "../components/AboutPage/AboutSection.js";
import SkillsSection from "../components/AboutPage/SkillsSection.js";

const About = () => {
  return (
    <div>
      <section >
        <AboutSection />
      </section>
      
      <section>
        <SkillsSection />
      </section>

      <section>
        <div className="h-64 bg-gray-800 bg-opacity-0 text-white px-6 py-12"></div>
      </section>

    </div>
  );
};

export default About;
